import { useEffect } from 'react';
import { log } from 'log';
import { path, prop } from 'ramda';
import { useCookieSettingsSelector, useSportsbookSelector } from 'js/store/hooks';

export const useSportsbookCookie = () => {
    const statisticsCookie = useCookieSettingsSelector(path(['groupsData', 'statistics']));
    const isAppInitialized = useSportsbookSelector(prop('isAppInitialized'));

    useEffect(() => {
        if (!window.Sportsbook || !isAppInitialized) {
            return;
        }

        try {
            window.Sportsbook.sendMessage('GIVE_COOKIE_CONSENT', { analytics: statisticsCookie });
        } catch (error) {
            log('log', '[SPORTSBOOK | Portal] Get balance error', error);
        }
    }, [statisticsCookie, isAppInitialized]);
};
